'use strict';

angular.module('directives.businessUnitMember', [])

.directive('businessUnitMember', [function () {
    return {
        scope: {
            buMember: '=',
            tplVersion: '@',
            moveToPrimary: '=',
            moveToForced: '=',
            showForcedIndicator: '='
        },
        template: '<span ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', function ($scope) {

            $scope.dirCtxt = {};

            $scope.getTemplateUrl = function () {
                var tplUrl = '/app/shared/components/directives/businessUnitMember.' +
                             $scope.tplVersion + '.tpl.html';

                return tplUrl;
            };

            $scope.clickOnBU = function () {
                if (!_.isUndefined($scope.moveToPrimary) && !_.isUndefined($scope.moveToPrimary.Action)) {
                    $scope.moveToPrimary.Action($scope.buMember);
                    return;
                }

                if (!_.isUndefined($scope.moveToForced) && !_.isUndefined($scope.moveToForced.Action)) {
                    $scope.moveToForced.Action($scope.buMember);
                    return;
                }
            };

            $scope.hoverIn = function () {
                $scope.dirCtxt.onHover = true;
            };

            $scope.hoverOut = function () {
                $scope.dirCtxt.onHover = false;
            };
        }],
        link: function (scope, elem, attrs) {
        }
    }
}]);
